export function PlusIcon({ className = '' }: { className?: string }) {
    return <div className={'bg-[image:var(--plus-svg)] bg-contain cursor-pointer ' + className} />;
}
